import { useLayoutEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthState } from 'state/client-middleware';
import bgAuthLight from 'assets/images/bg_auth_light.jpg';
import bgAuthDark from 'assets/images/bg_auth_dark.jpg';
import { useTheme } from 'components/core/theme-provider';
import { useWhiteLabelStore } from 'state/store/white-label';

export function AuthLayout() {
  const navigate = useNavigate();
  const { isMounted, isAuthenticated, isMfaEnabled } = useAuthState();
  const { theme } = useTheme();

  const { settings: whiteLabelSettings } = useWhiteLabelStore();

  // Determine which logo to use based on theme and white-label settings
  const loginBannerSrc = theme === 'dark'
    ? (whiteLabelSettings?.loginBannerUrlDarkMode || bgAuthDark)
    : (whiteLabelSettings?.loginBannerUrl || bgAuthLight);

  useLayoutEffect(() => {
    if (isAuthenticated && !isMfaEnabled) {
      navigate('/');
    }
  }, [isAuthenticated, isMfaEnabled, navigate]);

  if (!isMounted) return null;

  const getBackgroundImage = () => {
    if (theme === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? bgAuthDark : bgAuthLight;
    }
    return loginBannerSrc;
  };

  return (
    <div className="flex w-full h-screen">
      <div className="hidden md:block w-[36%] relative bg-primary-50">
        <img
          src={getBackgroundImage()}
          alt="bg auth"
          className="w-full h-full object-cover"
          key={theme ?? 'default'}
        />
      </div>
      <div className="flex items-center justify-center w-full px-6 sm:px-20 md:w-[64%] md:px-[12%] lg:px-[14%] 2xl:px-[18%]">
        <Outlet />
      </div>
    </div>
  );
}
